import api from '@/libs/axios'

export default {
  async create(payload) {
    const response = await api.post('/admin/mission-rewards', payload)
    return response.data.data.new_document || null
  },
  async update(payload) {
    return await api.put('/admin/mission-rewards', payload)
  },
  async delete(payload) {
    return await api.delete('/admin/mission-rewards', {
      data: payload,
    })
  },
  async getList(params) {
    return await api.get('/admin/mission-rewards', {
      params,
    })
  },
  async get(params) {
    let response = await api.get('/admin/mission-rewards/detail', {
      params,
    })
    return response.data.data.document || null
  },
  async getAll(params) {
    return await api.get('/admin/mission-rewards/all', {
      params,
    })
  },
  async updateDisplayOrder(payload) {
    return await api.post('/admin/mission-rewards/update-display-order', payload)
  }
}
